var app = angular.module('NectarApp', ['ow-cookbook']);

var config = function config($translateProvider) {
  'ngInject';

  var pathToTranslations = 'translations/';

  $translateProvider.useStaticFilesLoader({
    prefix: pathToTranslations,
    suffix: '.json',
  });
  $translateProvider.fallbackLanguage('en');

  // Configures how translations deal with dynamic strings; here we use escape html
  // $translateProvider.useSanitizeValueStrategy('escape');
}

app.config(config);

app.controller('connectCtrl', function($scope) {
  $scope.phone = {
      "fullNumber": "",
      "prefix": "+41",
      "number": ""
  };
  $scope.favoriteCountries = [
      "CH",
      "US",
      "CN"
  ];

  $scope.connect = function() {
    if(!$scope.callForm.$valid) return;
    window.scrollTo(0,0);
    $('body').css('background-image', (window.screen.availWidth < 1024)
      ? 'url(../images/closeUp_mobile_308x572.gif)'
      : 'url(../images/closeUp_desktop_1344x756.gif)');

    $scope.disableCall = true;
    $scope.buttonText="Calling...";
    pDriveIntegration($scope.name, $scope.phone.fullNumber);
  }

  function pDriveIntegration(name, phone) {
    var phoneNumber = phone.replace(/\+|\s/g, '');
    console.log('calling number', phoneNumber);
    $.ajax({
      contentType: 'application/json',
      data: JSON.stringify({
        "name":name,
        "phone":phoneNumber
      }),
      dataType: 'json',
      processData: false,
      type: 'POST',
      url: "https://i3gf8mhbzj.execute-api.us-west-2.amazonaws.com/production/"
    });
  }
});

function playVideo() {
  $('.video-overlay').show();

  // 2. This code loads the IFrame Player API code asynchronously.
  var tag = document.createElement('script');
  tag.src = "https://www.youtube.com/iframe_api";
  var firstScriptTag = document.getElementsByTagName('script')[0];
  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
}

// 3. This function creates an <iframe> (and YouTube player)
//    after the API code downloads.
var player;
function onYouTubeIframeAPIReady() {
  player = new YT.Player('video-container', {
    height: '390',
    width: '640',
    videoId: 'ZEV9ObHQk7w',
    playerVars: {
      rel: 0,
      'controls': 0,
      'fs' : 0,
      showinfo: 0
    },
    events: {
      'onReady': onPlayerReady,
      'onStateChange': onPlayerStateChange
    }
  });
}

function stopVideo() {
  if (player) {
    player.stopVideo();
  } else {
    $('#video-container iframe').each(function(i, el) {
      if(!window.YT) return;
      var player = new YT.Player(el);
      player.stopVideo();
    });
  }
}

function closeVideo() {
  stopVideo();
  $('.video-overlay').hide();
}

// 4. The API will call this function when the video player is ready.
function onPlayerReady(event) {
  event.target.playVideo();
}

// 5. The API calls this function when the player's state changes.
// The function indicates that when playing a video (state=1),
// the player should play for six seconds and then stop.
var done = false;
function onPlayerStateChange(event) {
  if (event.data == YT.PlayerState.PLAYING && !done) {
    done = true;
  }
}
